<template>
  <Drawer
    :id="drawerId"
    title="Add Tracking Detail"
  >
    <v-card flat>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="trackingNumber"
            label="Tracking Number"
            :rules="[$rules.required]"
            outlined
          />
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Add
        </v-btn>
      </div>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/layout/Drawer';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import enums from '../../../helpers/enums';
export default {
  name: 'PrintJobAddTracking',
  components: { Drawer },
  data() {
    return {
      valid: false,
      saving: false,
      job: {},
      trackingNumber: '',
      drawerId: enums.DRAWERS.PRINT_JOB_ADD_TRACKING
    };
  },
  computed: {
    drawerOpenedAt() {
      return this.$store.state.drawers.lastOpenedAt;
    },
    ...mapGetters({
      initialData: 'drawers/data'
    })
  },
  watch: {
    drawerOpenedAt() {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        this.job = cloneDeep(this.initialData(this.drawerId).job);
        this.trackingNumber = '';
      }
    }
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('orders/addTracking', {
          orderId: this.job.orderId,
          jobId: this.job.jobId,
          trackingNumber: this.trackingNumber,
          isPromo: this.job.isPromo || false
        })
        .then(() => {
          this.$store.commit('drawers/GO_BACK');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
